
    <ng-container *ngIf="options$ | async as options">
      <ag-grid-angular
        class="ag-theme-alpine fieldmagic-data-grid fieldmagic-data-grid-theme"
        [class.fieldmagic-data-grid-full]="size === 'full'"
        [class.fieldmagic-data-grid-lg]="size === 'lg'"
        [class.fieldmagic-data-grid-md]="size === 'md'"
        [rowData]="data$ | async"
        [columnDefs]="columns$ | async"
        [autoGroupColumnDef]="group$ | async"
        [frameworkComponents]="options.frameworkComponents"
        [rowGroupPanelShow]="options.rowGroupPanelShow"
        [getContextMenuItems]="options.getContextMenuItems"
        [getRowNodeId]="options.getRowNodeId"
        [rowGroupPanelShow]="options.rowGroupPanelShow"
        [defaultColDef]="{
          fullWidth: true,
          resizable: true
        }"
        [suppressAggFuncInHeader]="options.suppressAggFuncInHeader"
        [suppressDragLeaveHidesColumns]="true"
        [suppressMakeColumnVisibleAfterUnGroup]="true"
        [enableGroupEdit]="true"
        [rowSelection]="options.rowSelection"
        [isRowSelectable]="options.isRowSelectable"
        [enableCharts]="options.enableCharts"
        [enableRangeSelection]="options.enableRangeSelection"
        [suppressRowClickSelection]="true"
        [suppressRowDeselection]="true"
        [groupIncludeTotalFooter]="options.groupIncludeTotalFooter"
        [sideBar]="options.sideBar"
        [rowModelType]="options.rowModelType"
        [pagination]="options.pagination"
        [paginationPageSize]="options.paginationPageSize"
        [cacheBlockSize]="options.cacheBlockSize"
        [aggFuncs]="options.aggFuncs"
        (firstDataRendered)="onFirstDataRendered($event)"
        (gridReady)="onGridReady($event)"
        (columnRowGroupChanged)="options.onColumnRowGroupChanged($event)"
        (sortChanged)="onSortChanged($event)"
        (paginationChanged)="onPaginationChanged($event)"
        (cellValueChanged)="onCellChanged($event)"
      >
      </ag-grid-angular>
    </ng-container>
  